/* ============================================================
   smz-quote-form.js — Signmakerz Quote Form
   ============================================================ */

/* ── Config ── */
var SMZ_API_URL = 'https://submissions.signmakerz.com/api/submit/new-signmakerz';
var SMZ_UPLOAD_URL = 'https://imagescloudv2.codeblue.agency/api/image/upload';
var SMZ_ALT_URL = 'https://submissions.signmakerz.com/api/update/contact-alternative';
var SMZ_SESSION_KEY = 'signmakerz_session';

/* ── Private state ── */
var _smzQuoteUuid = null;
var _smzAirtableId = null;
var _smzImageUrl = '';
var _smzIsUploading = false;
var _smzImageSelected = false;
var _smzAltListenersInit = false;

/* ── Exit-intent state ── */
var _smzAllowLeave = false; // flipped true only when user clicks "Leave anyway"
var _smzFormDone = false; // flipped true after _smzSuccessUI() — nothing to intercept anymore

/*
 * FIX: Track the in-flight Step 1 API promise.
 *
 * WHY THIS IS NEEDED:
 * smzNextStep() sets _smzQuoteUuid to a local UUID immediately, then
 * transitions the UI to step 2 — all before the Step 1 API call has
 * resolved. This means a fast user (or slow network) can:
 *   1. Select sign types
 *   2. Upload an image (upload fires as soon as _smzQuoteUuid is truthy)
 *   3. Hit Submit
 * …all while _smzAirtableId is still null and _smzQuoteUuid may not yet
 * be the server-confirmed UUID.
 *
 * The PATCH (step 2) then sends a UUID/airtableId the server cannot
 * resolve → 404 "record not found".
 *
 * Solution: store the Step 1 promise in _smzStep1Promise. Both
 * smzHandleFiles and smzHandleSubmit await it before proceeding,
 * guaranteeing the server record exists and the correct UUID/airtableId
 * are in place before any subsequent API call is made.
 */
var _smzStep1Promise = null;
/*
 * Tracks whether Step 1 POST returned ok (DB record confirmed created).
 * Also true for restored sessions — they already have a server-confirmed record.
 * The PATCH finds records by UUID server-side, so _smzAirtableId being null
 * (e.g. Airtable hiccup during Step 1) is not a reason to block submission.
 */
var _smzStep1Succeeded = false;

/* ── Multi-file upload state ── */
// Each entry: { file, chip, xhr, url, done, failed }
// Each file uploads independently. Removing one doesn't touch the others.
var _smzStaged = [];

/* ── Placement / Lighting / Material (used by inline onclick) ── */
var smzPlacement = [];   // multi-select
var smzLighting = [];   // multi-select
var smzMaterial = [];   // multi-select

/* ============================================================
   UTILITIES
   ============================================================ */

function _smzVal(id) {
  var el = document.getElementById(id);
  return el ? el.value.trim() : '';
}

function _smzGetName() { return _smzVal('smz-f-name'); }

function _smzGetSignTypes() {
  return Array.prototype.map.call(
    document.querySelectorAll('.smz-mc.smz-sel'),
    function (e) { return e.dataset.type; }
  ).filter(Boolean);
}

function _smzUid() {
  return crypto.randomUUID
    ? crypto.randomUUID()
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
}

/* ── Error helpers ── */
function _smzShowErr(id) {
  var el = document.getElementById(id);
  if (el) el.classList.add('smz-show');
  var map = {
    'smz-e-name': 'smz-f-name',
    'smz-e-email': 'smz-f-email',
    'smz-e-phone': 'smz-f-phone'
  };
  var fid = map[id];
  if (fid) { var inp = document.getElementById(fid); if (inp) inp.classList.add('smz-err'); }
}

function smzClearErr(input, errId) {
  if (input) input.classList.remove('smz-err');
  var el = document.getElementById(errId);
  if (el) el.classList.remove('smz-show');
}

function smzClearUploadErr() {
  var el = document.getElementById('smz-e-upload');
  if (el) el.classList.remove('smz-show');
}

/* ── Button loading states ── */
function _smzLoadingNext(state) {
  var btn = document.getElementById('smz-btn-next');
  if (!btn) return;
  btn.disabled = state;
  btn.innerHTML = state
    ? '<span class="smz-ls"></span> Please wait...'
    : '<span>Continue to Sign Details</span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
}

function _smzLoadingSubmit(state, label) {
  var btn = document.getElementById('smz-btn-submit');
  if (!btn) return;
  btn.disabled = state;
  btn.innerHTML = state
    ? '<span class="smz-ls"></span> ' + (label || 'Submitting\u2026')
    : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2L11 13"/><path d="M22 2L15 22 11 13 2 9l20-7z"/></svg><span>Submit &amp; Get My Free Mockup</span>';
}

/* ── Step UI transitions ── */
function _smzGoToStep2() {
  document.getElementById('smz-fstep1').classList.remove('smz-active');
  document.getElementById('smz-fstep2').classList.add('smz-active');
  var sp1 = document.getElementById('smz-sp1');
  var sp2 = document.getElementById('smz-sp2');
  if (sp1) { sp1.classList.remove('smz-active'); sp1.classList.add('smz-done'); sp1.textContent = '\u2713 Contact'; }
  if (sp2) sp2.classList.add('smz-active');
  var fcb = document.getElementById('smz-form-callbar');
  if (fcb) fcb.style.display = 'none';
  var wrap = document.getElementById('smz-q-form-wrap');
  if (wrap) wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

function smzPrevStep() {
  document.getElementById('smz-fstep2').classList.remove('smz-active');
  document.getElementById('smz-fstep1').classList.add('smz-active');
  var sp1 = document.getElementById('smz-sp1');
  var sp2 = document.getElementById('smz-sp2');
  if (sp2) sp2.classList.remove('smz-active');
  if (sp1) { sp1.classList.add('smz-active'); sp1.classList.remove('smz-done'); sp1.textContent = 'Step 1: Contact'; }
  var fcb = document.getElementById('smz-form-callbar');
  if (fcb) fcb.style.display = '';
}

/* ── Placement / Lighting / Material ── */
function smzSetPlacement(v) {
  var idx = smzPlacement.indexOf(v);
  if (idx === -1) { smzPlacement.push(v); } else { smzPlacement.splice(idx, 1); }
  ['indoor', 'outdoor'].forEach(function (p) {
    var el = document.getElementById('smz-pl-' + p);
    if (el) el.classList.toggle('smz-active', smzPlacement.indexOf(p) !== -1);
  });
  var err = document.getElementById('smz-e-placement');
  if (err) err.classList.remove('smz-show');
}

function smzSetLighting(v) {
  var idx = smzLighting.indexOf(v);
  if (idx === -1) { smzLighting.push(v); } else { smzLighting.splice(idx, 1); }
  ['frontlit', 'backlit', 'frontback', 'none'].forEach(function (p) {
    var el = document.getElementById('smz-light-' + p);
    if (el) el.classList.toggle('smz-active', smzLighting.indexOf(p) !== -1);
  });
  var err = document.getElementById('smz-e-lighting');
  if (err) err.classList.remove('smz-show');
}

function smzSetMaterial(v) {
  var idx = smzMaterial.indexOf(v);
  if (idx === -1) { smzMaterial.push(v); } else { smzMaterial.splice(idx, 1); }
  ['acrylic', 'metal', 'notsure'].forEach(function (p) {
    var el = document.getElementById('smz-mat-' + p);
    if (el) el.classList.toggle('smz-active', smzMaterial.indexOf(p) !== -1);
  });
  var err = document.getElementById('smz-e-material');
  if (err) err.classList.remove('smz-show');
}

/* ── Hint popover ── */
function smzToggleHint(wrapId) {
  var wrap = document.getElementById(wrapId);
  if (!wrap) return;
  var isOpen = wrap.classList.toggle('smz-open');
  var btn = wrap.querySelector('.smz-hint-trigger');
  if (btn) btn.setAttribute('aria-expanded', isOpen);
}

document.addEventListener('click', function (e) {
  if (e.target.closest && e.target.closest('.smz-hint-wrap')) return;
  document.querySelectorAll('.smz-hint-wrap.smz-open').forEach(function (w) {
    w.classList.remove('smz-open');
    var b = w.querySelector('.smz-hint-trigger');
    if (b) b.setAttribute('aria-expanded', 'false');
  });
});

/* ============================================================
   SESSION
   ============================================================ */

function _smzSaveSession() {
  try {
    localStorage.setItem(SMZ_SESSION_KEY, JSON.stringify({
      quoteUuid: _smzQuoteUuid,
      airtableRecordId: _smzAirtableId,
      name: _smzVal('smz-f-name'),
      email: _smzVal('smz-f-email'),
      phone: _smzVal('smz-f-phone'),
      logoUrl: _smzVal('smz-f-logo-url'),
      placement: smzPlacement
    }));
  } catch (e) { }
}

function _smzClearSession() {
  try { localStorage.removeItem(SMZ_SESSION_KEY); } catch (e) { }
}

function _smzLoadSession() {
  try { var r = localStorage.getItem(SMZ_SESSION_KEY); return r ? JSON.parse(r) : null; }
  catch (e) { return null; }
}

function _smzRestoreSession() {
  var s = _smzLoadSession();
  if (!s || !s.quoteUuid) return;

  _smzQuoteUuid = s.quoteUuid;
  _smzAirtableId = s.airtableRecordId;

  function setField(id, v) { var el = document.getElementById(id); if (el && v) el.value = v; }
  setField('smz-f-name', s.name);
  setField('smz-f-email', s.email);
  setField('smz-f-phone', s.phone);
  setField('smz-f-logo-url', s.logoUrl);

  if (s.placement) {
    (Array.isArray(s.placement) ? s.placement : [s.placement]).forEach(function (v) { smzSetPlacement(v); });
  }

  // Restored sessions already have a confirmed server UUID — no pending promise.
  _smzStep1Promise = null;
  _smzStep1Succeeded = true;

  _smzGoToStep2();
  console.log('SMZ: session restored, UUID =', _smzQuoteUuid);
}

/* ============================================================
   API CALLS
   ============================================================ */

async function _smzApiStep1(id) {
  var logoUrl = _smzVal('smz-f-logo-url');
  var doneFileUrls = _smzStaged
    .filter(function (s) { return s.done && s.url; })
    .map(function (s) { return s.url; });

  var payload = {
    uuid: id,
    name: _smzGetName(),
    email: _smzVal('smz-f-email'),
    phone: _smzVal('smz-f-phone'),
    details: _smzVal('smz-f-details'),
    business_website: logoUrl,
    image_url: doneFileUrls.join(','),
    sign_placement: smzPlacement.join(', '),
    lead_page_url: window.location.href,
    first_click: localStorage.getItem('first_click'),
    entry_url: localStorage.getItem('entry_url'),
    first_visit: localStorage.getItem('first_visit'),
    event_source: localStorage.getItem('event_keys_data'),
    Created_at: new Date().toISOString(),
    leadSource: sessionStorage.getItem('currentURL') || '',
    current_page_param: new URL(window.location.href).pathname.split('/').pop(),
    location: localStorage.getItem('locationxh'),
    submission_step: 'S1 Submitted'
  };
  var res = await fetch(SMZ_API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(payload)
  });
  var data = await res.json().catch(function () { return {}; });
  if (!res.ok) throw new Error(data.message || 'Step 1 failed');
  return {
    uuid: (data.data && data.data.uuid) || id,
    airtableRecordId: (data.airtableRecordId && data.airtableRecordId.id) || null
  };
}

async function _smzApiStep1Update() {
  _smzRecomputeImageUrl();
  var payload = {
    uuid: _smzQuoteUuid,
    airtableRecordId: _smzAirtableId,
    name: _smzGetName(),
    email: _smzVal('smz-f-email'),
    phone: _smzVal('smz-f-phone'),
    details: _smzVal('smz-f-details'),
    business_website: _smzVal('smz-f-logo-url'),
    image_url: _smzImageUrl,
    sign_placement: smzPlacement.join(', ')
  };
  var res = await fetch(SMZ_API_URL, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(payload)
  });
  var data = await res.json().catch(function () { return {}; });
  if (!res.ok) throw new Error(data.message || 'Contact update failed');
  _smzSaveSession();
  return data;
}

async function _smzApiStep2(uuid, imageUrl, airId) {
  var payload = {
    uuid: uuid,
    airtableRecordId: airId,
    image_url: imageUrl,
    sign_placements: smzPlacement,
    sign_placement: smzPlacement.join(', '),
    lighting_options: smzLighting,
    lighting_option: smzLighting.join(', '),
    sign_materials: smzMaterial,
    sign_material: smzMaterial.join(', '),
    estimated_size: _smzVal('smz-f-size'),
    details: _smzVal('smz-f-details'),
    submission_step: 'S2 Completed'
  };
  var res = await fetch(SMZ_API_URL, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(payload)
  });
  var data = await res.json().catch(function () { return {}; });
  if (!res.ok) throw new Error(data.message || 'Step 2 failed');
  return data;
}

/* ============================================================
   IMAGE UPLOAD
   ============================================================ */

// Upload a single file. Returns { promise, xhr } so the caller can abort.
function _smzUploadOne(file, name, id, onProgress) {
  var fd = new FormData();
  fd.append('name', name);
  fd.append('page_url', window.location.href);
  fd.append('uuid', id);
  fd.append('images[]', file);

  var xhr = new XMLHttpRequest();
  var promise = new Promise(function (resolve, reject) {
    xhr.upload.addEventListener('progress', function (e) {
      if (e.lengthComputable && onProgress) onProgress(Math.round(e.loaded / e.total * 100));
    });
    xhr.addEventListener('load', function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          var data = JSON.parse(xhr.responseText);
          var urls = data.imageUrls || [];
          // Single file in → expect single URL out. Take the first; fall back to joined.
          resolve(urls[0] || urls.join(','));
        } catch (e) { reject(new Error('Invalid upload response')); }
      } else { reject(new Error('Image upload failed (' + xhr.status + ')')); }
    });
    xhr.addEventListener('error', function () { reject(new Error('Image upload network error')); });
    xhr.addEventListener('abort', function () { reject(new Error('Image upload aborted')); });
    xhr.open('POST', SMZ_UPLOAD_URL);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.send(fd);
  });
  return { promise: promise, xhr: xhr };
}

function _smzCreateChip(fileName) {
  var el = document.createElement('div'); el.className = 'smz-upload-chip';
  var top = document.createElement('div'); top.className = 'smz-upload-chip-top';
  var nameEl = document.createElement('span'); nameEl.className = 'smz-upload-chip-name';
  nameEl.textContent = fileName.length > 28 ? fileName.slice(0, 26) + '\u2026' : fileName;
  var status = document.createElement('span');
  status.className = 'smz-upload-chip-status smz-uploading'; status.textContent = '0%';
  var x = document.createElement('button'); x.className = 'smz-upload-chip-x'; x.type = 'button'; x.textContent = '\xd7';
  top.appendChild(nameEl); top.appendChild(status); top.appendChild(x);
  var track = document.createElement('div'); track.className = 'smz-upload-chip-bar-track';
  var fill = document.createElement('div'); fill.className = 'smz-upload-chip-bar-fill';
  track.appendChild(fill); el.appendChild(top); el.appendChild(track);
  return { el: el, fill: fill, status: status, xBtn: x };
}

/* ============================================================
   FILE HANDLER  (called by onchange / drop)
   ============================================================ */

// Recompute the comma-joined URL string from all done uploaded file entries.
// Logo/website URL is kept separate (sent as business_website in payloads).
// Also updates _smzImageSelected and _smzIsUploading aggregate state.
function _smzRecomputeImageUrl() {
  var doneUrls = _smzStaged
    .filter(function (s) { return s.done && s.url; })
    .map(function (s) { return s.url; });
  _smzImageUrl = doneUrls.join(',');

  _smzImageSelected = !!_smzVal('smz-f-logo-url') || _smzStaged.length > 0;
  _smzIsUploading = _smzStaged.some(function (s) { return !s.done && !s.failed; });
}

// Start uploading a single staged entry. Stores xhr on the entry so removal can abort it.
function _smzStartEntryUpload(entry) {
  entry.done = false;
  entry.failed = false;
  entry.url = '';

  var handle = _smzUploadOne(entry.file, _smzGetName(), _smzQuoteUuid, function (pct) {
    if (entry.removed) return;
    entry.chip.fill.style.width = pct + '%';
    entry.chip.status.textContent = pct + '%';
  });
  entry.xhr = handle.xhr;

  handle.promise.then(function (url) {
    if (entry.removed) return;
    entry.url = url;
    entry.done = true;
    entry.xhr = null;
    entry.chip.fill.style.width = '100%';
    entry.chip.fill.classList.add('smz-done');
    entry.chip.status.classList.remove('smz-uploading');
    entry.chip.status.classList.add('smz-done');
    entry.chip.status.textContent = '\u2713 Done';
    console.log('SMZ: file uploaded —', entry.file.name, '→', url);
    _smzRecomputeImageUrl();
  }).catch(function (e) {
    if (entry.removed) return; // abort due to user remove — silent
    entry.failed = true;
    entry.xhr = null;
    console.error('SMZ upload error (' + entry.file.name + '):', e.message);
    entry.chip.fill.style.width = '0%';
    entry.chip.status.classList.remove('smz-uploading');
    entry.chip.status.textContent = 'Failed';
    entry.chip.status.style.color = '#C0392B';
    _smzRecomputeImageUrl();
  });
}

// Remove a single staged file (called when a chip × is clicked).
function _smzRemoveStaged(entry) {
  var idx = _smzStaged.indexOf(entry);
  if (idx === -1) return;

  entry.removed = true;
  // Abort its upload if still pending.
  if (entry.xhr) { try { entry.xhr.abort(); } catch (e) { } entry.xhr = null; }

  _smzStaged.splice(idx, 1);
  if (entry.chip && entry.chip.el && entry.chip.el.parentNode) {
    entry.chip.el.parentNode.removeChild(entry.chip.el);
  }

  // Clear the native input so re-selecting the same file would fire onchange again.
  var inp = document.getElementById('smz-file-input');
  if (inp) inp.value = '';

  _smzRecomputeImageUrl();
}

function smzHandleFiles(files) {
  if (!files || !files.length) return;

  var ue = document.getElementById('smz-e-upload');
  if (ue) ue.classList.remove('smz-show');

  var container = document.getElementById('smz-file-previews');
  if (!container) return;

  // Assign a local UUID immediately so uploads start right away.
  // smzNextStep() reuses this same UUID for the step 1 API call.
  if (!_smzQuoteUuid) {
    _smzQuoteUuid = _smzUid();
    console.log('SMZ: early UUID assigned for upload =', _smzQuoteUuid);
  }

  Array.prototype.forEach.call(files, function (f) {
    var chip = _smzCreateChip(f.name);
    container.appendChild(chip.el);
    var entry = {
      file: f,
      chip: chip,
      xhr: null,
      url: '',
      done: false,
      failed: false,
      removed: false
    };
    chip.xBtn.onclick = function () { _smzRemoveStaged(entry); };
    _smzStaged.push(entry);
    _smzStartEntryUpload(entry);
  });

  // Clear the native input so picking the same filename again still fires onchange.
  var inp = document.getElementById('smz-file-input');
  if (inp) inp.value = '';

  _smzRecomputeImageUrl();
}

function smzHandleDrop(e) {
  e.preventDefault();
  var zone = document.getElementById('smz-upload-zone');
  if (zone) zone.classList.remove('smz-drag-over');
  smzHandleFiles(e.dataTransfer.files);
}


/* ============================================================
   NEXT STEP  (Step 1 → Step 2)
   ============================================================ */

async function smzNextStep() {

  /* Clear errors */
  ['smz-e-name', 'smz-e-email', 'smz-e-phone'].forEach(function (id) {
    var el = document.getElementById(id); if (el) el.classList.remove('smz-show');
  });
  ['smz-f-name', 'smz-f-email', 'smz-f-phone'].forEach(function (id) {
    var el = document.getElementById(id); if (el) el.classList.remove('smz-err');
  });

  /* Validate */
  var name = _smzVal('smz-f-name');
  var email = _smzVal('smz-f-email');
  var phone = _smzVal('smz-f-phone');
  var logoUrl = _smzVal('smz-f-logo-url');
  var valid = true;
  if (!name) { _smzShowErr('smz-e-name'); valid = false; }
  if (!email || !/\S+@\S+\.\S+/.test(email)) { _smzShowErr('smz-e-email'); valid = false; }
  if (!phone || phone.replace(/\D/g, '').length < 7) { _smzShowErr('smz-e-phone'); valid = false; }
  if (!logoUrl && _smzStaged.length === 0) {
    var ue = document.getElementById('smz-e-upload'); if (ue) ue.classList.add('smz-show'); valid = false;
  }
  if (!valid) return;

  /* ── Returning user (server record confirmed) ── */
  // Only take this path when _smzStep1Succeeded is true, meaning a real server
  // record exists. _smzQuoteUuid alone is NOT enough — it may have been assigned
  // early by smzHandleFiles before any API call was made.
  if (_smzQuoteUuid && _smzStep1Succeeded) {
    // Transition immediately — same pattern as the new lead path.
    // PUT fires in the background after any in-flight uploads settle,
    // so the user never sees a "Please wait…" on the Continue button.
    _smzGoToStep2();
    (async function () {
      _smzRecomputeImageUrl();
      if (_smzIsUploading) {
        await new Promise(function (resolve) {
          var iv = setInterval(function () {
            _smzRecomputeImageUrl();
            if (!_smzIsUploading) { clearInterval(iv); resolve(); }
          }, 300);
        });
        _smzRecomputeImageUrl();
      }
      try { await _smzApiStep1Update(); } catch (e) { console.error('SMZ contact update failed:', e.message); }
    })();
    return;
  }

  /* ── New lead ── */
  // Reuse UUID if already assigned by early file upload; otherwise generate now.
  if (!_smzQuoteUuid) {
    _smzQuoteUuid = _smzUid();
  }
  var localId = _smzQuoteUuid;
  console.log('SMZ: UUID for step 1 API =', localId);

  _smzGoToStep2();
  _smzLoadingNext(true);

  // Wait for any in-flight uploads to finish before posting Step 1, so the
  // API call includes the uploaded image URLs. The entire chain is stored in
  // _smzStep1Promise so smzHandleSubmit can await it if needed.
  _smzStep1Promise = new Promise(function (resolve) {
    _smzRecomputeImageUrl();
    if (!_smzIsUploading) { resolve(); return; }
    var iv = setInterval(function () {
      _smzRecomputeImageUrl();
      if (!_smzIsUploading) { clearInterval(iv); resolve(); }
    }, 300);
  })
    .then(function () {
      _smzRecomputeImageUrl();
      return _smzApiStep1(localId);
    })
    .then(function (result) {
      _smzQuoteUuid = result.uuid;
      _smzAirtableId = result.airtableRecordId;
      _smzStep1Succeeded = true;
      _smzSaveSession();
      window.history.pushState({}, '', window.location.pathname + '?thanks-for-response');
      try { gtag_report_conversion(); } catch (ge) { /* gtag optional */ }
      console.log('SMZ: step 1 API ok, server UUID =', _smzQuoteUuid);
    })
    .catch(function (e) {
      console.error('SMZ: step 1 API error:', e.message);
    })
    .finally(function () {
      _smzStep1Promise = null;
      _smzLoadingNext(false);
    });
}

/* ============================================================
   HANDLE SUBMIT  (Step 2)
   ============================================================ */

async function smzHandleSubmit() {

  if (!_smzQuoteUuid) {
    alert('Session expired. Please refresh the page.');
    return;
  }

  var pe = document.getElementById('smz-e-placement');
  var le = document.getElementById('smz-e-lighting');
  var mte = document.getElementById('smz-e-material');
  if (pe) pe.classList.remove('smz-show');
  if (le) le.classList.remove('smz-show');
  if (mte) mte.classList.remove('smz-show');

  var valid = true;
  if (!smzPlacement.length) { if (pe) pe.classList.add('smz-show'); valid = false; }
  if (!smzLighting.length) { if (le) le.classList.add('smz-show'); valid = false; }
  if (!smzMaterial.length) { if (mte) mte.classList.add('smz-show'); valid = false; }
  if (!valid) return;

  // Show success screen immediately — same pattern as step 1 transitioning to step 2.
  // PATCH fires in the background once step 1 API and uploads have both settled.
  var _uuid = _smzQuoteUuid;
  var _airId = _smzAirtableId;
  _smzSuccessUI();

  (async function () {
    // 1. Wait for step 1 API if still in-flight (ensures DB record exists)
    if (_smzStep1Promise) {
      try { await _smzStep1Promise; } catch (e) { }
    }
    if (!_smzStep1Succeeded) {
      console.error('SMZ: step 2 skipped — step 1 record not confirmed');
      return;
    }

    // 2. Wait for any in-flight file uploads so image_url is complete
    _smzRecomputeImageUrl();
    if (_smzIsUploading) {
      await new Promise(function (resolve) {
        var iv = setInterval(function () {
          _smzRecomputeImageUrl();
          if (!_smzIsUploading) { clearInterval(iv); resolve(); }
        }, 300);
      });
      _smzRecomputeImageUrl();
    }

    // 3. Fire PATCH with confirmed UUID and final image URLs
    try {
      await _smzApiStep2(_uuid, _smzImageUrl, _airId);
      console.log('SMZ: step 2 submitted ok');
    } catch (e) {
      console.error('SMZ: step 2 API error:', e.message);
    }
  })();
}

/* ============================================================
   SUCCESS SCREEN
   ============================================================ */

function _smzSuccessUI() {
  // Mark form as fully done — exit guard disables itself
  _smzFormDone = true;

  var email = _smzVal('smz-f-email');
  var phone = _smzVal('smz-f-phone');
  var tyEmail = document.getElementById('smz-ty-email');
  var tyPhone = document.getElementById('smz-ty-phone');
  if (tyEmail) tyEmail.value = email;
  if (tyPhone) tyPhone.value = phone;

  _smzInitAltContactListeners();
  _smzClearSession();

  document.getElementById('smz-q-form-wrap').style.display = 'none';
  var suc = document.getElementById('smz-q-success');
  suc.style.display = 'block';
  setTimeout(function () {
    var svg = document.getElementById('smz-ty-check-svg');
    if (svg) svg.classList.add('smz-draw');
  }, 200);
  suc.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/* ── Alternative contact auto-save (debounced 1.5 s) ── */
function _smzInitAltContactListeners() {
  if (_smzAltListenersInit) return;
  _smzAltListenersInit = true;

  [
    { inputId: 'smz-ty-email', field: 'email' },
    { inputId: 'smz-ty-phone', field: 'phone' }
  ].forEach(function (cfg) {
    var input = document.getElementById(cfg.inputId);
    if (!input) return;
    var saved = input.value.trim();
    var timer = null;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var current = input.value.trim();
      if (current === saved) return;
      timer = setTimeout(async function () {
        var payload = { uuid: _smzQuoteUuid };
        if (cfg.field === 'email') payload.alternative_email = current;
        else payload.alternative_phone = current;
        try {
          var res = await fetch(SMZ_ALT_URL, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          });
          var data = await res.json().catch(function () { return {}; });
          if (!res.ok) throw new Error(data.message || 'Update failed');
          saved = current;
          console.log('SMZ: alt contact saved:', cfg.field);
        } catch (e) {
          console.error('SMZ alt contact update failed:', e.message);
        }
      }, 1500);
    });
  });
}

/* ============================================================
   EXIT INTENT POPUP
   ============================================================ */

// Only intercept when Step 1 is done but Step 2 is not yet submitted
function _smzShouldIntercept() {
  return _smzQuoteUuid && !_smzFormDone;
}

function _smzShowExitPopup() {
  var overlay = document.getElementById('smz-exit-intent-overlay');
  if (overlay) overlay.style.display = 'flex';
}

function _smzHideExitPopup() {
  var overlay = document.getElementById('smz-exit-intent-overlay');
  if (overlay) overlay.style.display = 'none';
  _smzAllowLeave = false;
}

function _smzInjectExitPopup() {
  if (document.getElementById('smz-exit-intent-overlay')) return;

  var overlay = document.createElement('div');
  overlay.id = 'smz-exit-intent-overlay';
  overlay.style.cssText = [
    'display:none',
    'position:fixed',
    'inset:0',
    'z-index:99999',
    'background:rgba(0,0,0,0.58)',
    'align-items:center',
    'justify-content:center',
    'padding:1rem'
  ].join(';');

  overlay.innerHTML = '' +
    '<div style="' +
    'background:#fff;' +
    'border-radius:16px;' +
    'padding:2.2rem 2rem 1.75rem;' +
    'max-width:420px;' +
    'width:100%;' +
    'border:1px solid rgba(0,0,0,0.1);' +
    'box-shadow:0 24px 64px rgba(0,0,0,0.28);' +
    'text-align:center;' +
    '">' +
    '<div style="' +
    'width:56px;height:56px;border-radius:50%;' +
    'background:#FFF3CD;border:2px solid #F4A61D;' +
    'display:flex;align-items:center;justify-content:center;' +
    'margin:0 auto 1.25rem;' +
    '">' +
    '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" ' +
    'stroke="#F4A61D" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>' +
    '<line x1="12" y1="9" x2="12" y2="13"/>' +
    '<line x1="12" y1="17" x2="12.01" y2="17"/>' +
    '</svg>' +
    '</div>' +
    '<p style="' +
    'font-family:\'Poppins\',sans-serif;' +
    'font-size:15px;' +
    'color:#333;' +
    'line-height:1.7;' +
    'margin:0 0 1.75rem;' +
    'padding:0 0.25rem;' +
    '">' +
    'It seems like there is some additional information required for an accurate ' +
    '<strong style="color:#111;font-weight:700;">price quote</strong>' +
    ' and ' +
    '<strong style="color:#111;font-weight:700;">mockup</strong>' +
    ' of your sign.' +
    '</p>' +
    '<button id="smz-exit-popup-stay" style="' +
    'width:100%;padding:14px;border-radius:8px;' +
    'background:#C4855F;border:none;color:#fff;' +
    'font-family:\'Bebas Neue\',sans-serif;' +
    'font-size:15px;letter-spacing:.1em;text-transform:uppercase;' +
    'cursor:pointer;margin-bottom:10px;' +
    'transition:background .18s;' +
    '">Provide Missing Information</button>' +
    '<button id="smz-exit-popup-leave" style="' +
    'width:100%;padding:12px;border-radius:8px;' +
    'background:transparent;border:1px solid #ddd;' +
    'color:#999;font-family:\'Poppins\',sans-serif;font-size:13px;' +
    'cursor:pointer;transition:color .18s,border-color .18s;' +
    '">Leave Anyways</button>' +
    '</div>';

  document.body.appendChild(overlay);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) _smzHideExitPopup();
  });

  document.getElementById('smz-exit-popup-stay').addEventListener('click', function () {
    _smzHideExitPopup();
    var form = document.getElementById('smz-q-form-wrap');
    if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  document.getElementById('smz-exit-popup-leave').addEventListener('click', function () {
    _smzHideExitPopup();
    _smzAllowLeave = true;
    window.history.go(-2);
  });
}

function _smzInitExitGuard() {

  // 1. Tab close / address-bar URL change — native browser dialog
  window.addEventListener('beforeunload', function (e) {
    if (!_smzShouldIntercept() || _smzAllowLeave) return;
    e.preventDefault();
    e.returnValue = ''; // required for Chrome to show the dialog
  });

  // 2. Browser back button — custom popup
  // Push a dummy state so the back button is interceptable
  if (window.history && window.history.pushState) {
    window.history.pushState({ smzExitGuard: true }, '');

    window.addEventListener('popstate', function () {
      if (!_smzShouldIntercept() || _smzAllowLeave) return;
      // Re-push so the guard stays active for repeated back attempts
      window.history.pushState({ smzExitGuard: true }, '');
      _smzShowExitPopup();
    });
  }
}

/* ============================================================
   RESET
   ============================================================ */

function smzResetForm() {
  _smzAltListenersInit = false;
  _smzStep1Promise = null;
  _smzStep1Succeeded = false;
  _smzQuoteUuid = null;
  _smzAirtableId = null;
  _smzImageUrl = '';
  _smzIsUploading = false;
  _smzImageSelected = false;
  _smzAllowLeave = false;
  _smzFormDone = false;
  smzPlacement = [];
  smzLighting = [];
  smzMaterial = [];
  // Abort any in-flight per-file uploads
  _smzStaged.forEach(function (s) {
    s.removed = true;
    if (s.xhr) { try { s.xhr.abort(); } catch (e) { } }
  });
  _smzStaged = [];
  _smzClearSession();

  document.getElementById('smz-q-success').style.display = 'none';
  var wrap = document.getElementById('smz-q-form-wrap');
  wrap.style.display = '';

  document.getElementById('smz-fstep2').classList.remove('smz-active');
  document.getElementById('smz-fstep1').classList.add('smz-active');
  var sp1 = document.getElementById('smz-sp1');
  var sp2 = document.getElementById('smz-sp2');
  if (sp1) { sp1.classList.add('smz-active'); sp1.classList.remove('smz-done'); sp1.textContent = 'Step 1: Contact'; }
  if (sp2) sp2.classList.remove('smz-active');
  var fcb = document.getElementById('smz-form-callbar');
  if (fcb) fcb.style.display = '';

  ['smz-f-name', 'smz-f-email', 'smz-f-phone', 'smz-f-logo-url', 'smz-f-details', 'smz-f-size'].forEach(function (id) {
    var el = document.getElementById(id); if (el) el.value = '';
  });
  document.querySelectorAll('.smz-fi.smz-err').forEach(function (el) { el.classList.remove('smz-err'); });
  document.querySelectorAll('.smz-fe.smz-show').forEach(function (el) { el.classList.remove('smz-show'); });
  document.querySelectorAll('.smz-mc.smz-sel').forEach(function (el) { el.classList.remove('smz-sel'); });

  var fp = document.getElementById('smz-file-previews');
  if (fp) fp.innerHTML = '';

  _smzLoadingSubmit(false);
  ['indoor', 'outdoor'].forEach(function (p) { var el = document.getElementById('smz-pl-' + p); if (el) el.classList.remove('smz-active'); });
  ['frontlit', 'backlit', 'frontback', 'none'].forEach(function (p) { var el = document.getElementById('smz-light-' + p); if (el) el.classList.remove('smz-active'); });
  ['acrylic', 'metal', 'notsure'].forEach(function (p) { var el = document.getElementById('smz-mat-' + p); if (el) el.classList.remove('smz-active'); });
  wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/* ============================================================
   MOSAIC BACKGROUND
   ============================================================ */

(function () {
  var bg = document.getElementById('smzBg');
  if (!bg) return;
  var PHOTOS = [
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3d_halo_lit_sign.webp?v=1726726381',
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/metal_letters_LE_ml_resize_custom.jpg?v=1726056610',
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/acrylic_letters_LE_ml_resize_custom.jpg?v=1726056610',
    'https://cdn.shopify.com/s/files/1/0929/6606/0311/files/categories-1_jpg_ed8ae8e2-0a88-4d98-b8ab-b94f809b0656.webp?v=1745995525',
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/metal_flat_cut.webp?v=1726053405',
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/wall_mounted_lightbox_LE_ml_resize_custom.jpg?v=1726053663',
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/hollow_cut_backlit.webp?v=1726726381',
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/acrylic_flat_cut.webp?v=1726053397',
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/4b2f1d3449ce312f59fd4f7343b17b6a.webp?v=1726818239',
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/printed_sign.webp?v=1726726381',
    'https://cdn.shopify.com/s/files/1/0929/6606/0311/files/8_360x_662bb246-a0cc-4a09-af6f-b75fcbc42e90.png--8.webp?v=1745661485',
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/push_through_lightbox_LE_ml_resize_custom.jpg?v=1726053663',
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/whole_lit_loghtbox.jpg?v=1726053663',
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Adhesive_Acrylic_Wall_Sign.webp?v=1726728662',
    'https://cdn.shopify.com/s/files/1/0699/3553/0271/files/printed_sign_with_halo_lit_backboard_LE_ml_resize_custom.jpg?v=1726056610'
  ];
  function getCols() {
    var w = window.innerWidth;
    return w >= 1200 ? 5 : w >= 768 ? 4 : 2;
  }
  function build() {
    bg.innerHTML = '';
    var cols = getCols();
    for (var c = 0; c < cols; c++) {
      var col = document.createElement('div'); col.className = 'smz-bg-col';
      var cp = [];
      for (var i = c; i < PHOTOS.length; i += cols) cp.push(PHOTOS[i]);
      if (!cp.length) cp = PHOTOS.slice(0, 3);
      var triple = cp.concat(cp).concat(cp);
      triple.forEach(function (src) {
        var img = document.createElement('img');
        img.className = 'smz-bg-img'; img.src = src; img.alt = '';
        img.loading = 'eager'; img.decoding = 'async';
        col.appendChild(img);
      });
      bg.appendChild(col);
    }
  }
  build();
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 200); });
})();

/* ============================================================
   EXPOSE PUBLIC API
   Shopify may load this script as a module or in a sandboxed
   scope where top-level functions are not automatically on
   window. Any function referenced by an inline onclick / onchange
   attribute in the HTML must be explicitly assigned to window.
   ============================================================ */

window.smzSetPlacement = smzSetPlacement;
window.smzSetLighting = smzSetLighting;
window.smzSetMaterial = smzSetMaterial;
window.smzNextStep = smzNextStep;
window.smzPrevStep = smzPrevStep;
window.smzHandleSubmit = smzHandleSubmit;
window.smzHandleFiles = smzHandleFiles;
window.smzHandleDrop = smzHandleDrop;
window.smzToggleHint = smzToggleHint;
window.smzResetForm = smzResetForm;
window.smzClearUploadErr = smzClearUploadErr;

/* ============================================================
   INIT
   ============================================================ */

function _smzInit() {
  _smzRestoreSession();
  _smzInjectExitPopup();
  _smzInitExitGuard();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', _smzInit);
} else {
  _smzInit();
}

console.log('SMZ quote form loaded \u2713');

/* ====================================================================
   PROSPECT LEAD — on-blur partial save (audit trail)
   Independent of main form flow. One row per user, kept updated as
   they fill fields. Survives page unload via fetch keepalive.
   ==================================================================== */
(function () {

  const PROSPECT_URL = 'https://submissions.signmakerz.com/api/prospect-lead/save';
  const PROSPECT_UUID_KEY = 'smz_prospect_uuid';

  let prospectUuid = null;
  const lastSavedValues = {};

  /* ---------------- UUID ---------------- */

  function uuid() {
    return crypto.randomUUID
      ? crypto.randomUUID()
      : 'xxxxxx-4xxx-yxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
  }

  function getProspectUuid() {
    if (prospectUuid) return prospectUuid;
    try {
      prospectUuid = localStorage.getItem(PROSPECT_UUID_KEY);
    } catch (e) { }
    if (!prospectUuid) {
      prospectUuid = uuid();
      try {
        localStorage.setItem(PROSPECT_UUID_KEY, prospectUuid);
      } catch (e) { }
    }
    return prospectUuid;
  }

  /* ---------------- HELPERS ---------------- */

  function getCurrentSignTypes() {
    return [...document.querySelectorAll('.smz-mc.smz-sel')]
      .map(e => e.dataset.type)
      .filter(Boolean);
  }

  function getSignTypesString(arr) {
    const labels = {
      lightbox: 'Lightbox / Cabinet Signs',
      halo: 'Halo lit / 3D Metal Backlit Signs',
      facelit: 'Face lit / 3D Frontlit Signs',
      flatcut: 'Flat cut signs / 2D Letter Sign',
      fabricated: 'Fabricated / 3D Non-Lit Signs / 3D Metal Letters',
      pushthrough: 'Push Through / Push-Thru Letters',
    };
    return arr.map(t => labels[t] || t).join(', ');
  }

  /* ---------------- SAVE FUNCTION ---------------- */

  async function saveProspectField(field, value) {
    // Skip if unchanged
    if (lastSavedValues[field] === value) return;

    // Skip if empty
    if (value === '' || value === null || value === undefined) return;

    // For arrays (signtypes), skip if empty
    if (Array.isArray(value) && value.length === 0) return;

    lastSavedValues[field] = value;

    const payload = {
      uuid: getProspectUuid(),
      page_url: window.location.href,
      location: localStorage.getItem('locationxh') || '',
    };
    payload[field] = value;

    if (field === 'signtypes') {
      payload.signtypes_string = getSignTypesString(value);
    }

    try {
      await fetch(PROSPECT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      });
    } catch (e) {
      console.warn('SMZ prospect save failed:', e.message);
    }
  }

  /* ---------------- LISTENERS ---------------- */

  function initProspectBlurListeners() {

    // Text inputs — fire on blur, only if value actually changed
    const textFields = [
      { id: 'smz-f-name', key: 'name' },
      { id: 'smz-f-email', key: 'email' },
      { id: 'smz-f-phone', key: 'phone' },
      { id: 'smz-f-logo-url', key: 'logo_url' },
      { id: 'smz-f-details', key: 'details' },
      { id: 'smz-f-size', key: 'estimated_size' },
    ];

    textFields.forEach(({ id, key }) => {
      const el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('blur', () => {
        saveProspectField(key, el.value.trim());
      });
    });

    // Placement (Indoor / Outdoor) — fire on click
    ['smz-pl-indoor', 'smz-pl-outdoor'].forEach(id => {
      const btn = document.getElementById(id);
      if (!btn) return;
      btn.addEventListener('click', () => {
        // window.smzPlacement is updated by smzSetPlacement() in the main script
        setTimeout(() => saveProspectField('placement', (window.smzPlacement || []).join(', ')), 0);
      });
    });

    // Sign type cards — fire when toggled
    document.querySelectorAll('.smz-mc[data-type]').forEach(card => {
      card.addEventListener('click', () => {
        setTimeout(() => {
          const types = getCurrentSignTypes();
          saveProspectField('signtypes', types);
        }, 0);
      });
    });
  }

  /* ---------------- INIT ---------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProspectBlurListeners);
  } else {
    initProspectBlurListeners();
  }

})();